import { useState } from "react";
import { Pencil, Save, X } from "lucide-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload, faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";

const EducationDetails = () => {
    const [isEditing, setIsEditing] = useState(false);
    const [educationList, setEducationList] = useState([
        {
            id: 1,
            instituteName: "Infisuite",
            type: "Regular",
            startDate: "2025-03-03",
            endDate: "2025-04-04",
            score: "5",
            subjectTaken: "English",
        },
    ]);

    const handleChange = (id, e) => {
        const { name, value } = e.target;
        setEducationList((prevList) =>
            prevList.map((edu) =>
                edu.id === id ? { ...edu, [name]: value } : edu
            )
        );
    };

    const handleSave = () => {
        setIsEditing(false);
    };

    const handleAddRow = () => {
        setEducationList([
            ...educationList,
            {
                id: educationList.length + 1,
                instituteName: "",
                type: "Regular",
                startDate: "",
                endDate: "",
                score: "",
                subjectTaken: "",
            },
        ]);
    };

    const handleDeleteRow = (id) => {
        setEducationList(educationList.filter((edu) => edu.id !== id));
    };

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
                <h5 className="mb-0">Education Details</h5>
                <div>
                    {isEditing && (
                        <button onClick={handleSave} className="btn btn-success btn-sm me-2">
                            <Save size={18} className="me-1" /> Save
                        </button>
                    )}
                    <button onClick={() => setIsEditing(!isEditing)} className="border-0 bg-transparent">
                        {isEditing ? <X className="text-danger" size={20} /> : <Pencil className="text-primary" size={20} />}
                    </button>
                </div>
            </div>

            <div className="card-block">
                <div className="table-responsive">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>Institute Name</th>
                                <th>Type</th>
                                <th>Start Date</th>
                                <th>End Date</th>
                                <th>Score</th>
                                <th>Subject Taken</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {educationList.map((edu) => (
                                <tr key={edu.id}>
                                    <td>
                                        {isEditing ? (
                                            <input
                                                type="text"
                                                name="instituteName"
                                                className="form-control input-me f-14"
                                                value={edu.instituteName}
                                                onChange={(e) => handleChange(edu.id, e)}
                                            />
                                        ) : (
                                            <p className="mb-0 f-13">{edu.instituteName}</p>
                                        )}
                                    </td>
                                    <td>
                                        {isEditing ? (
                                            <select
                                                name="type"
                                                className="form-control input-me f-14"
                                                value={edu.type}
                                                onChange={(e) => handleChange(edu.id, e)}
                                            >
                                                <option>Regular</option>
                                                <option>Online</option>
                                            </select>
                                        ) : (
                                            <p className="mb-0 f-13">{edu.type}</p>
                                        )}
                                    </td>
                                    <td>
                                        {isEditing ? (
                                            <input
                                                type="date"
                                                name="startDate"
                                                className="form-control input-me f-14"
                                                value={edu.startDate}
                                                onChange={(e) => handleChange(edu.id, e)}
                                            />
                                        ) : (
                                            <p className="mb-0 f-13">{edu.startDate}</p>
                                        )}
                                    </td>
                                    <td>
                                        {isEditing ? (
                                            <input
                                                type="date"
                                                name="endDate"
                                                className="form-control input-me f-14"
                                                value={edu.endDate}
                                                onChange={(e) => handleChange(edu.id, e)}
                                            />
                                        ) : (
                                            <p className="mb-0 f-13">{edu.endDate}</p>
                                        )}
                                    </td>
                                    <td>
                                        {isEditing ? (
                                            <input
                                                type="text"
                                                name="score"
                                                className="form-control input-me f-14"
                                                value={edu.score}
                                                onChange={(e) => handleChange(edu.id, e)}
                                            />
                                        ) : (
                                            <p className="mb-0 f-13">{edu.score}</p>
                                        )}
                                    </td>
                                    <td>
                                        {isEditing ? (
                                            <input
                                                type="text"
                                                name="subjectTaken"
                                                className="form-control input-me f-14"
                                                value={edu.subjectTaken}
                                                onChange={(e) => handleChange(edu.id, e)}
                                            />
                                        ) : (
                                            <p className="mb-0 f-13">{edu.subjectTaken}</p>
                                        )}
                                    </td>
                                    <td align="right">
                                        <button className="btn text-info p-0 f-12 me-3">
                                            <FontAwesomeIcon icon={faUpload} />
                                        </button>
                                        <button
                                            className="btn text-danger p-0 f-12"
                                            onClick={() => handleDeleteRow(edu.id)}
                                        >
                                            <FontAwesomeIcon icon={faTrash} />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <button className="btn btn-primary btn-sm mt-2" onClick={handleAddRow}>
                        <FontAwesomeIcon icon={faPlus} /> Add More
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EducationDetails;
